<template>
  <v-container>
    <v-layout row wrap>
      <v-flex v-if="showCloudLoginCard" class="card-container" xs12 md6>
        <cloud-login-card/>
      </v-flex>
      <v-flex class="card-container" xs12 md4>
        <my-card/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex';
  import MyCard from './MyCard';
  import CloudLoginCard from './CloudLoginCard';

  export default {
    components: { MyCard, CloudLoginCard },
    computed: {
      showCloudLoginCard() {
        return 'cloud' in this.user.scopes || 'enterprise' in this.user.scopes;
      },
      ...mapState('auth', [
        'user'
      ])
    }
  };
</script>

<style lang="less" scoped>
  .card-container {
    padding: 20px;
  }
</style>
